var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"srm-time-sign"},[(!_vm.status||!_vm.status.status)?_c('span'):_c('a-tooltip',{attrs:{"overlayClassName":"g-table-tooltip","placement":"topLeft","title":_vm.status.remark}},[(Boolean(_vm.status.icon))?_c('a-icon',{class:_vm.status.class,attrs:{"type":_vm.status.icon,"theme":"filled"}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3afda460","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/srm-sign/srm-time-sign.vue
// module id = null
// module chunks = 